// @flow

import * as React from "react";
import ReactMarkdown from "react-markdown";

import GenderDisclaimer from "./GenderDisclaimer.md";
import LegalNotice from "./LegalNotice.md";
import PrivacyPolicy from "./PrivacyPolicy.md";
import TermsAndConditions from "./TermsAndConditions.md";
import GeneralGuaranteeConditions from "./GeneralGuaranteeConditions.md";

import styles from "./LegalPage.scss";

export type LegalPageType =
  | "genderDisclaimer"
  | "legalNotice"
  | "privacyPolicy"
  | "termsAndConditions"
  | "generalGuaranteeConditions";

type LegalPageProps = {
  type: LegalPageType
};

const getFileContent = (type: LegalPageType) => {
  switch (type) {
    case "genderDisclaimer":
      return GenderDisclaimer;
    case "legalNotice":
      return LegalNotice;
    case "privacyPolicy":
      return PrivacyPolicy;
    case "termsAndConditions":
      return TermsAndConditions;
    case "generalGuaranteeConditions":
      return GeneralGuaranteeConditions;
    default:
      return LegalNotice;
  }
};

const LegalPage = ({ type }: LegalPageProps) => (
  <div className={styles.wrapper}>
    <ReactMarkdown>{getFileContent(type)}</ReactMarkdown>
  </div>
);

export default LegalPage;
